import styled from 'styled-components';
import Text from '../../Atoms/Text/Text';
import Link from '../../Atoms/Link/Link';
import zIndex from '../../../theme/shared/zIndex';
import spacing from '../../../theme/shared/spacing';
var CookieWrapper = styled.div.withConfig({
  displayName: "CookieBannerstyle__CookieWrapper",
  componentId: "m69qcz-0"
})(["display:flex;position:relative;padding:", ";background:", ";flex-direction:column;", ";"], spacing('md'), function (_ref) {
  var theme = _ref.theme;
  return theme.color('deep_violet_dark');
}, zIndex('high'));
var CookieText = styled(Text).withConfig({
  displayName: "CookieBannerstyle__CookieText",
  componentId: "m69qcz-1"
})(["line-height:1.5;margin:0;&:first-of-type{margin-bottom:", ";}@media ", "{width:75%;margin:", " auto;&:first-of-type{margin-bottom:", ";}}"], spacing('sm'), function (_ref2) {
  var theme = _ref2.theme;
  return theme.breakpoint('small');
}, spacing('none'), spacing('md'));
var AcceptCookieBtn = styled(Link).withConfig({
  displayName: "CookieBannerstyle__AcceptCookieBtn",
  componentId: "m69qcz-2"
})(["padding:", " ", ";display:block;margin-bottom:10px;@media ", "{margin:0 ", " 0 0;display:inline-block;}"], spacing('sm'), spacing('md'), function (_ref3) {
  var theme = _ref3.theme;
  return theme.breakpoint('small');
}, spacing('xsm'));
var LinkStyle = styled(Link).withConfig({
  displayName: "CookieBannerstyle__LinkStyle",
  componentId: "m69qcz-3"
})(["color:", ";padding:0 ", " 1px;border-bottom:2px solid;"], function (_ref4) {
  var theme = _ref4.theme;
  return theme.color('white');
}, spacing('xsm'));
export { CookieWrapper, CookieText, AcceptCookieBtn, LinkStyle };